import { DetailsHeader, Tooltip } from '@discretize/gw2-ui-new';
import AccessibilityNewOutlined from '@mui/icons-material/AccessibilityNewOutlined';
import { ListItem, ListItemText } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Specialization } from '.';
import Link from '../navigation/Link';
import SimpleList from '../SimpleList';

const useStyles = makeStyles()((theme) => ({
  container: {
    whitespace: 'nowrap',
  },
}));

export const COMPOSITIONS = [
  {
    name: 'Rainbow',
    comp: ['Firebrand', 'Soulbeast', 'Berserker', 'Weaver', 'Renegade'],
    roles: [
      'DPS/Quickness',
      'DPS/CC',
      'DPS/CC/Banner',
      'DPS',
      'DPS/Alacrity/CC',
    ],
  },
  {
    name: 'Rainbearbow',
    comp: ['Firebrand', 'Soulbeast', 'Soulbeast', 'Weaver', 'Renegade'],
    roles: [
      'DPS/Quickness',
      'DPS/CC/Buffs',
      'DPS/CC/Buffs',
      'DPS',
      'DPS/Alacrity/CC',
    ],
  },
  {
    name: 'RGB',
    comp: [
      'Dragonhunter',
      'Dragonhunter',
      'Soulbeast',
      'Soulbeast',
      'Renegade',
    ],
    roles: [
      'DPS/Quickness',
      'DPS/Quickness',
      'DPS/CC/Buffs',
      'DPS/CC/Buffs',
      'DPS/Alacrity/CC',
    ],
  },
  {
    name: 'CRGB',
    comp: ['Firebrand', 'Firebrand', 'Soulbeast', 'Soulbeast', 'Renegade'],
    roles: [
      'DPS/CC/Quickness',
      'DPS/CC/Quickness',
      'DPS/Moa',
      'DPS/Sun Spirit',
      'DPS/Alacrity/CC',
    ],
  },
];

const zip = (a, b) => a.map((k, i) => [k, b[i]]);

function Composition({ composition, name, roles, size }) {
  const { classes } = useStyles();

  let compContainer;
  if (name.charAt(0) === '_') {
    compContainer = COMPOSITIONS.find((e) => e.name === name.substr(1));
  } else {
    compContainer = {
      name: name.trim(),
      comp: composition
        .toString()
        .split(',')
        .map((e) => e.trim()),
      roles: roles
        .toString()
        .split(',')
        .map((e) => e.trim()),
    };
  }

  const nonTooltip = (
    <span className={classes.container}>
      <Link to="/guides/effective-comp">
        {
          // TODO ADD LINK TO ANCHORS TO COMPS
        }
        {compContainer.comp.map((e, index) => {
          if (e === 'x') {
            return (
              <React.Fragment key={`pug${index.toString()}`}>
                {' '}
                <AccessibilityNewOutlined fontSize="small" />
              </React.Fragment>
            );
          }
          return (
            <React.Fragment key={`_${name}${index.toString()}${e}`}>
              {' '}
              <Specialization size={size} disableText name={e} />
            </React.Fragment>
          );
        })}
        {compContainer.name.length > 0 && <> {compContainer.name}</>}
      </Link>
    </span>
  );

  return (
    <Tooltip
      content={
        <>
          <DetailsHeader>{compContainer.name}</DetailsHeader>
          <SimpleList>
            {zip(compContainer.comp, compContainer.roles).map((e, index) => {
              if (e[0] === 'x') {
                return (
                  <ListItem key={`empty${index.toString()}`}>
                    {' '}
                    <AccessibilityNewOutlined fontSize="small" />
                  </ListItem>
                );
              }
              return (
                <ListItem key={name + e[0] + index.toString()}>
                  <ListItemText
                    primary={
                      <div>
                        {' '}
                        <Specialization name={e[0]} />
                      </div>
                    }
                    secondary={
                      e[1] ? (
                        <>
                          {'      '}
                          {e[1]}
                        </>
                      ) : null
                    }
                  />
                </ListItem>
              );
            })}
          </SimpleList>
        </>
      }
    >
      {nonTooltip}
    </Tooltip>
  );
}

Composition.defaultProps = {
  size: 'medium',
  roles: '',
  composition: '',
};
Composition.propTypes = {
  composition: PropTypes.string,
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  roles: PropTypes.string,
};

export default Composition;
